import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { ApiInterceptor } from './core/interceptor/api-interceptor';
import { ComponentsModule } from './components/components.module';
import { GlobalErrorHandler } from './core/diagnostics/global-error-handler';
import { PendingRequestsInterceptor } from './core/pwa/pending-requests.interceptor';

// Socket.IO configuration logic to handle possible URL prefixes in the endpoint
const getSocketConfig = (): SocketIoConfig => {
    let url = environment.socketEndpoint;
    let path = '/socket.io';

    try {
        const parsedUrl = new URL(environment.socketEndpoint);
        url = parsedUrl.origin;
        if (parsedUrl.pathname !== '/') {
            path = parsedUrl.pathname.endsWith('/') ? parsedUrl.pathname + 'socket.io' : parsedUrl.pathname + '/socket.io';
        }
    } catch (e) {
        console.warn('Invalid socketEndpoint URL, using defaults', e);
    }

    return {
        url: url,
        options: {
            transports: ['websocket'],
            path: path
        }
    };
};

const socketConfig: SocketIoConfig = getSocketConfig();

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot(),
        BrowserAnimationsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Registrazione dopo la stabilizzazione dell'app (o 30s) per non competere con l'avvio
            registrationStrategy: 'registerWhenStable:30000'
        }),
        SocketIoModule.forRoot(socketConfig),
        ComponentsModule
    ],
    declarations: [AppComponent],
    providers: [
        { provide: HTTP_INTERCEPTORS, useExisting: PendingRequestsInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        InAppBrowser, SplashScreen, StatusBar
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
